import { useQuery } from "@tanstack/react-query";
import { ApiError } from "@/lib/api-client";
import { fetchMe } from "./api";
import type { auth } from "@duress/shared";

export interface UseAuthResult {
  user: auth.AuthedUser | null;
  isLoading: boolean;
  // True only when the backend confirmed there's no valid session (401).
  // Distinct from a network/server failure, which should show an error
  // rather than bounce the user into a login redirect loop.
  isUnauthenticated: boolean;
  error: unknown;
  refetch: () => void;
}

export function useAuth(): UseAuthResult {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["auth", "me"],
    queryFn: fetchMe,
    retry: false,          // don't retry 401 — unauthenticated is not a transient error
    staleTime: 5 * 60_000, // re-check every 5 minutes
  });

  return {
    user: data ?? null,
    isLoading,
    isUnauthenticated: error instanceof ApiError && error.status === 401,
    error,
    refetch: () => void refetch(),
  };
}
